import { render, staticRenderFns } from "./TextareaComponent.vue?vue&type=template&id=7c779a02&"
import script from "./TextareaComponent.vue?vue&type=script&lang=js&"
export * from "./TextareaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TextareaComponent.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports